import update from './update';

export default {
  update,
};
